<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('art_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('art_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P017'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/0" class="resserve-button"> 예약신청 </router-link>-->
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="60" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div>{{ $t('art_desc1') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('art_common_title') }}</div>
          <div class="subDatail">
            <div>{{ $t('art_common_desc1') }}</div>
            <div>{{ $t('art_common_desc2') }}</div>
            <div>{{ $t('art_common_desc3') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('art_main_title') }}</div>
          <div class="row d-flex">
            <div v-for="(item, index) in sub_items" :key="index" class="col-lg-4 col-12 mb-4">
              <template>
                <div class="card">
                  <a :href="item.href">
                    <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
                  /></a>
                  <div class="card-body">
                    <h5 class="card-title" style="letter-spacing: -0.02rem">{{ $t(item.title) }}</h5>
                    <p class="card-text" style="font-size: 0.8rem; word-break: keep-all; height: 5rem">
                      {{ $t(item.desc) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="rowSpace"></div>
          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('art_table1_tr1_td1') }}</td>
                <td>{{ $t('art_table1_tr1_td2') }}</td>
                <td>{{ $t('art_table1_tr1_td3') }}</td>
                <td>{{ $t('art_table1_tr1_td4') }}</td>
                <td>{{ $t('art_table1_tr1_td5') }}</td>
                <td>{{ $t('art_table1_tr1_td6') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('art_table1_tr2_td1') }}</td>
                <td>{{ $t('art_table1_tr2_td2') }}</td>
                <td>{{ $t('art_table1_tr2_td3') }}</td>
                <td>{{ $t('art_table1_tr2_td4') }}</td>
                <td>{{ $t('art_table1_tr2_td5') }}</td>
                <td>{{ $t('art_table1_tr2_td6') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="rowSpace"><hr /></div>
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('art_addition_title') }}</div>

          <GallerySlideCarousels :slides="addition_slides" :slide-count="4" :thumb-slide-width="50" />

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('art_table2_tr1_td1') }}</td>
                <td colspan="2">{{ $t('art_table2_tr1_td2') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('art_table2_tr2_td1') }}</td>
                <td>{{ $t('art_table2_tr2_td2') }}</td>
                <td rowspan="5">{{ $t('art_table2_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('art_table2_tr3_td1') }}</td>
                <td>{{ $t('art_table2_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('art_table2_tr4_td1') }}</td>
                <td>{{ $t('art_table2_tr4_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('art_table2_tr5_td1') }}</td>
                <td>{{ $t('art_table2_tr5_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('art_table2_tr6_td1') }}</td>
                <td>Inclusive / Luxury / Premium</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('art_etc_title') }}</div>
          <div class="subDetail">
            <div>{{ $t('art_etc_desc1') }}</div>
            <div>{{ $t('art_etc_desc2') }}</div>
            <div>{{ $t('art_etc_desc3') }}</div>
            <div>{{ $t('art_etc_desc4') }}</div>
            <div>{{ $t('art_etc_desc5') }}</div>
            <div>{{ $t('art_etc_desc6') }}</div>
            <div>{{ $t('art_etc_desc7') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P017'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/0" class="resserve-button"> 예약신청 </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'artnhealing',
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/artnhealing_main_01.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_main_02.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_main_03.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_main_04.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_main_05.jpg')},
      ],
      addition_slides: [
        {image: require('@/assets/images/pleisure/program/artnhealing_option_01.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_option_02.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_option_03.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_option_04.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_option_05.jpg')},
        {image: require('@/assets/images/pleisure/program/artnhealing_option_06.jpg')},
      ],
      sub_items: [
        {
          title: 'art_mainp_title1',
          desc: 'art_mainp_desc1',
          image: require('@/assets/images/pleisure/program/artnhealing_thumb_01.jpg'),
        },
      ],
    };
  },
  components: {Breadcrumb, GallerySlideCarousels},
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
      word-break: keep-all;
    }
  }
}
.subTable2 {
  font-weight: bold;
}
.subTable3 {
  background-color: #f3f3f3;
  font-weight: bold;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program/artnhealing_headerimage.jpg');
}

@media (min-width: 992px) {
  .web {
  }

  .mobile {
    display: none;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "art_title": "아트앤힐링",
    "art_subtitle": "세계적 건축가와 예술가의 손길을 따라서",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "art_desc1": "ʻ제 2의 고향’ 제주에 최고의 후기 작품들을 남긴 이타미 준의 대표작들과 건축계의 노벨상인 ʻ프리츠커상ʻ 수상자 안도 다다오의 건축물까지 세계적으로 인정받는 건축가 2인의 작품을 전문 가이드의 설명과 함께 관람할 수 있습니다. 또한 떠오르는 복합 전시 공간 포도뮤지엄에서 만나는 아티스트들의 작품들까지 건축, 문화, 예술이 결합된 레저 프로그램을 경험해 보세요.",
    "art_common_title": "공통 의전 및 서비스",
    "art_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "art_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "art_common_desc3": "- 어메니티, 미니바 제공",
    "art_main_title": "메인 프로그램",
    "art_mainp_title1": "건축문화투어",
    "art_mainp_desc1": "포도호텔, 방주교회, 본태박물관 포도뮤지엄 큐레이팅 (150분)",
    "art_table1_tr1_td1": "옵션",
    "art_table1_tr1_td2": "시간",
    "art_table1_tr1_td3": "최대인원",
    "art_table1_tr1_td4": "소요시간",
    "art_table1_tr1_td5": "요금(2인기준)",
    "art_table1_tr1_td6": "추가옵션",
    "art_table1_tr2_td1": "건축문화투어",
    "art_table1_tr2_td2": "150분",
    "art_table1_tr2_td3": "6인",
    "art_table1_tr2_td4": "3H",
    "art_table1_tr2_td5": "550,000",
    "art_table1_tr2_td6": "※ 인원추가 +80,000 원 / 인",
    "art_addition_title": "추가옵션",
    "art_table2_tr1_td1": "구분",
    "art_table2_tr1_td2": "옵션(2인기준)",
    "art_table2_tr2_td1": "150,000",
    "art_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "art_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "art_table2_tr3_td1": "200,000",
    "art_table2_tr3_td2": "메디컬 스파(바디)",
    "art_table2_tr4_td1": "350,000",
    "art_table2_tr4_td2": "오모로비짜 스파(90분)",
    "art_table2_tr5_td1": "500,000",
    "art_table2_tr5_td2": "스냅(요트)",
    "art_table2_tr6_td1": "플라워 세팅",
    "art_etc_title": "기타사항",
    "art_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "art_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "art_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "art_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "art_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "art_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "art_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  },
  "en": {
    "breadcrumb": "Program Information",
    "art_title": "Art & Healing",
    "art_subtitle": "Following footsteps of the world-renowned architects and artists.",
    "prev_button": "Previous",
    "reserve_button": "Book Now",
    "art_desc1": "You can see the works of two world-renowned architects along with the explanation of the professional guide, which includes the representative works of Itami Jun who left the best works in his second hometown, Jeju, and the works of Ando Tadao who won Pritzker Architectural Prize, Nobel Prize in the architectural industry. Also, experience a leisure program that integrates architecture, culture, and art, including the works of artists exhibited in the PODO museum, a rising complex exhibition space.",
    "art_common_title": "Common escort service and other services",
    "art_common_desc1": "- Escort vehicle service (Benz Sprinter / Carnival High Limousine)",
    "art_common_desc2": "- Care service by the PINX escort manager",
    "art_common_desc3": "- Free amenities and minibar",
    "art_main_title": "Main Program",
    "art_mainp_title1": "Architecturer&Culture tour",
    "art_mainp_desc1": "Art Curation- Podohotel, ark of Noah Church, Bontemuseum, Podomuseum (150min.)",
    "art_table1_tr1_td1": "Option",
    "art_table1_tr1_td2": "Running time",
    "art_table1_tr1_td3": "Maximum Occupancy",
    "art_table1_tr1_td4": "Total Time",
    "art_table1_tr1_td5": "Fare(2 people)",
    "art_table1_tr1_td6": "Additional person",
    "art_table1_tr2_td1": "Architecturer&Culture tour",
    "art_table1_tr2_td2": "150 min",
    "art_table1_tr2_td3": "6 people",
    "art_table1_tr2_td4": "3H",
    "art_table1_tr2_td5": "KRW 550,000",
    "art_table1_tr2_td6": "※ + KRW 80,000/ 1people",
    "art_addition_title": "Addtional Options",
    "art_table2_tr1_td1": "Fare",
    "art_table2_tr1_td2": "Option(2 person)",
    "art_table2_tr2_td1": "KRW 150,000",
    "art_table2_tr2_td2": "Water therapy, Shooting, Omorovicza Spa(40min.)",
    "art_table2_tr2_td3": "※ More than 3 people, please contact us",
    "art_table2_tr3_td1": "KRW 200,000",
    "art_table2_tr3_td2": "Medical Spa(Body)",
    "art_table2_tr4_td1": "KRW 350,000",
    "art_table2_tr4_td2": "Omorovicza Spa(90min.)",
    "art_table2_tr5_td1": "KRW 500,000",
    "art_table2_tr5_td2": "Snapshot(Yacht)",
    "art_table2_tr6_td1": "Flower service",
    "art_etc_title": "Others",
    "art_etc_desc1": "※ A fare applies for children aged 5 or older.",
    "art_etc_desc2": "※ In some cases, minors may need a guardian.",
    "art_etc_desc3": "※ The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind.",
    "art_etc_desc4": "- Penalty will be charged 0% until 7 days prior to the reserved date, 30% from 5 to 6 days before, 50% until 4 days before, 70% until 2 to 3 days before (by 5pm), and no refund will be made(100% penalty) after 5pm 2 days prior to the reserved date.",
    "art_etc_desc5": "※ In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "art_etc_desc6": "※ Traveler's insurance is included in the product.",
    "art_etc_desc7": "※ Contact us by phone for the group of people other than the number in the price list."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "art_title": "아트앤힐링",
    "art_subtitle": "세계적 건축가와 예술가의 손길을 따라서",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "art_desc1": "ʻ제 2의 고향’ 제주에 최고의 후기 작품들을 남긴 이타미 준의 대표작들과 건축계의 노벨상인 ʻ프리츠커상ʻ 수상자 안도 다다오의 건축물까지 세계적으로 인정받는 건축가 2인의 작품을 전문 가이드의 설명과 함께 관람할 수 있습니다. 또한 떠오르는 복합 전시 공간 포도뮤지엄에서 만나는 아티스트들의 작품들까지 건축, 문화, 예술이 결합된 레저 프로그램을 경험해 보세요.",
    "art_common_title": "공통 의전 및 서비스",
    "art_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "art_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "art_common_desc3": "- 어메니티, 미니바 제공",
    "art_main_title": "메인 프로그램",
    "art_mainp_title1": "건축문화투어",
    "art_mainp_desc1": "포도호텔, 방주교회, 본태박물관 포도뮤지엄 큐레이팅 (150분)",
    "art_table1_tr1_td1": "옵션",
    "art_table1_tr1_td2": "시간",
    "art_table1_tr1_td3": "최대인원",
    "art_table1_tr1_td4": "소요시간",
    "art_table1_tr1_td5": "요금(2인기준)",
    "art_table1_tr1_td6": "추가옵션",
    "art_table1_tr2_td1": "건축문화투어",
    "art_table1_tr2_td2": "150분",
    "art_table1_tr2_td3": "6인",
    "art_table1_tr2_td4": "3H",
    "art_table1_tr2_td5": "550,000",
    "art_table1_tr2_td6": "※ 인원추가 +80,000 원 / 인",
    "art_addition_title": "추가옵션",
    "art_table2_tr1_td1": "구분",
    "art_table2_tr1_td2": "옵션(2인기준)",
    "art_table2_tr2_td1": "150,000",
    "art_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "art_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "art_table2_tr3_td1": "200,000",
    "art_table2_tr3_td2": "메디컬 스파(바디)",
    "art_table2_tr4_td1": "350,000",
    "art_table2_tr4_td2": "오모로비짜 스파(90분)",
    "art_table2_tr5_td1": "500,000",
    "art_table2_tr5_td2": "스냅(요트)",
    "art_table2_tr6_td1": "플라워 세팅",
    "art_etc_title": "기타사항",
    "art_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "art_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "art_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "art_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "art_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "art_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "art_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  }
}
</i18n>
